import BuscaSimplesCards from '@/components/BuscaSimplesCards.vue';

export const mixinAtoAdministrativo = {
  components: {
    BuscaSimplesCards,
  },
  data() {
    return {
        cardsAtoAdministrativo: [
            {
              rota: 'PorTipoAtoAdministrativo',
              icone: require('@/assets/images/icon-tipo-legislacao2.png'),
              iconeClasse: 'legisla-icon',
              titulo: 'Tipo de Ato',
              descricao: 'Consulte Atos Administrativos<br /> por <strong>tipo</strong>',
            },
            {
              rota: 'PorAnoAtoAdministrativo',
              icone: require('@/assets/images/icon-indice-cronologico2.png'),
              iconeClasse: 'indice-icon',
              titulo: 'Índice Cronológico',
              descricao: 'Consulte Atos Administrativos<br /> por <strong>ano</strong>',
            },
          ],
    };
  },
};